import { isEmpty, trim } from 'lodash';

import {
  IPdfColumn,
  IPdfContent,
  IPdfTools,
  PdfSelectColumn,
  PdfSummaryFields,
} from './pdf.type';
import { truncateText } from './utils';
import { IPdfData } from './pdf-data.type';
import { ContentColumns, ContentText } from 'pdfmake/interfaces';
import { PdfContentType } from './pdf-content.enum';
import { TRANSFER_PDF_HEADER_VALUES } from '@app/shared/types/enums/transfer-pdf.enum';
import { GLOBAL_CHARGEABLE_TEXT } from '@config/global-constants';
import { I18n } from '@app/i18n/strings-keys';

/**
 * this is for A4 print summary search field define
 */
const SEARCH_SUMMARY_DEFINE: PdfSummaryFields = {
  [I18n.Common.Search]: {
    path: 'gridFilterString',
    valueFormatter: ({ value, tools }): string => {
      const wholeLineSearchTextWidth = 875;

      return truncateText(value, tools, wholeLineSearchTextWidth);
    },
    hidden: ({ value }): boolean => isEmpty(trim(value)),
    style: {
      noWrap: true,
    },
  },
};

/**
 * this is for A4 print chargeable tips define
 */
const CHARGEABLE_TIPS_DEFINE: IPdfContent = {
  type: PdfContentType.Tips,
  setting: (): string[] => {
    return [I18n.InfoMessages.$IndicatesChargeableItemsBrackets];
  },
};

const CHARGEABLE_COLUMN_DEFINE: IPdfColumn = {
  width: 6,
  path: TRANSFER_PDF_HEADER_VALUES.isChargeable,
  title: '',
  valueGetter: (params): string => {
    const isChargeable = params.value ?? params.rowData?.is_chargeable;

    return isChargeable ? '$' : '';
  },
};

const CHARGEABLE_SELECT_COLUMN_DEFINE: PdfSelectColumn = {
  title: GLOBAL_CHARGEABLE_TEXT,
  path: TRANSFER_PDF_HEADER_VALUES.isChargeable,
  required: true,
};

const getSearchHeaderDefine = (
  searched: boolean,
  pdfData: IPdfData,
  tools: IPdfTools,
): ContentText | ContentColumns => {
  const { i18nService } = tools.services;

  const wholeLineSearchTextWidth = 930;

  return searched
    ? {
        fontSize: 8,
        margin: [20, 5, 20, 0],
        columns: [
          {
            text: [
              { text: i18nService.translate(I18n.Forms.GridForm.SearchColon) },
              {
                text: truncateText(
                  pdfData?.gridFilterString,
                  tools,
                  wholeLineSearchTextWidth,
                ),
                bold: true,
              },
            ],
          },
        ],
        style: {
          noWrap: true,
        },
      }
    : null;
};
export {
  SEARCH_SUMMARY_DEFINE,
  CHARGEABLE_TIPS_DEFINE,
  CHARGEABLE_COLUMN_DEFINE,
  CHARGEABLE_SELECT_COLUMN_DEFINE,
  getSearchHeaderDefine,
};
